module.exports = __webpack_public_path__ + "static/media/reg5kz.4046752f.pdf";